module.exports = (amount) => {
    let css = '[times] 4em [track-1-start] 0.5fr';
    for(let i = 1; i < amount; i++) {
        css += ' [track-' + i + '-end track-' + (i+1) + '-start] 0.5fr '
    }
    css += ' [track-5-end]';
    return css;
}